@if (showLoginModal) {
  <lib-login-modal
    [labels]="'lib.loginModal' | translate"
    [bank]="theme"
    [pwdError]="pwdError"
    [emailError]="emailError"
    (close)="closeDialog()"
    (login)="onLogin($event)"
    (forgotPassword)="goToPwdReset()"
    (createAccount)="onSignUp()"
    (googleLogin)="onGmailLogin()"
  ></lib-login-modal>
}
